import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import getUserBookings from "./getUserBookings";
import getBookingStep from "./getBookingStep";
import getSpecificBooking from "./getSpecificBooking";
import getUserContract from "./getUserContract";
import getHourlyProductionData from "./getHourlyProductionData";
import getDailyProductionData from "./getDailyProductionData";
import checkMantencion from "./checkMantencion";

import { LoadingWheel } from "../../styles/loading";
import { HomeBanner } from "../../styles/banners";

import HomePreSigned from "./HomePreSigned";
import HomePending2nd from "./HomePending2nd";
import HomeSigned from "./HomeSigned";
import HomeEntreVisitaInstall from "./HomeEntreVisitaInstall";
import HomePostInstalation from "./HomePostInstalation";
import HomePostTermino from "./HomePostTermino";

import Footer from "../../styles/footers";

import PopUpMantencion from "./PopUpMantencion";
import { PostInstallationDocuments, PostInstallationMedia } from "../../types/responseTypes";
import getInstallationDocuments from "../Installation/getInstallationDocuments";
import getInstallationMedia from "../Installation/getInstallationMedia";

import {
  UserData,
  UserBooking,
  SpecificBooking,
  UserContract,
  ProductionData,
} from "../../types/responseTypes";


const Home: React.FC = () => {
  const location = useLocation();
  console.log("location: ", location);
  const { userData, bookingIndex } = location.state as {
    userData: UserData;
    bookingIndex: number;
  };

  const [userBookings, setUserBookings] = useState<UserBooking[]>([]);
  const [selectedBookingIndex, setSelectedBookingIndex] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [bookingStep, setBookingStep] = useState<number | null>(null);
  const [mantencionDifference, setMantencionDifference] = useState<number>(0);
  const [isPopUpVisible, setIsPopUpVisible] = useState<boolean>(false);
  const [specificBooking, setSpecificBooking] = useState<SpecificBooking | null>(null);
  const [userContract, setUserContract] = useState<UserContract | null>(null);

  const [dailyProductionData, setDailyProductionData] = React.useState<ProductionData[] | null>([]);
  const [hourlyProductionData, setHourlyProductionData] = React.useState<ProductionData[] | null>([]);

  const [installationDocuments, setInstallationDocuments] = useState<PostInstallationDocuments | null>(null);
  const [installationMedia, setInstallationMedia] = useState<PostInstallationMedia | null>(null);

  useEffect(() => {
    const fetchInstallationData = async () => {
      try {
        if (userBookings[selectedBookingIndex]?.installationId) { // algunos bookings no tienen installationId
          const documents = await getInstallationDocuments(userBookings[selectedBookingIndex]);
          setInstallationDocuments(documents);
          const media = await getInstallationMedia(userBookings[selectedBookingIndex]);
          setInstallationMedia(media);
          console.log("Installation data fetched:", installationDocuments, installationMedia);
        } 
      } catch (error) {
        console.error("Error fetching installation data:", error);
      }
    };
    fetchInstallationData();
  }, [userBookings[selectedBookingIndex]]);

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const bookings = await getUserBookings();
        setUserBookings(bookings);

        if (bookings.length > 0) {
          setSelectedBookingIndex(bookingIndex);
        }
      } catch (error) {
        console.error("Error fetching user bookings:", error);
      }
    };

    fetchInitialData();
  }, []);

  useEffect(() => {
    const fetchBookingData = async () => {
      if (
        userBookings.length > 0 &&
        userBookings[selectedBookingIndex].bookingId
      ) {
        await fetchSpecificBookingAndStep(selectedBookingIndex);
        setLoading(false);
      }
    };

    fetchBookingData();
  }, [userBookings, selectedBookingIndex]);

  const fetchSpecificBookingAndStep = async (index: number) => {
    const booking = userBookings[index];
    console.log("current booking: ", booking);
    if (!booking || !booking.bookingId) {
      console.error("Invalid booking data or bookingId is undefined");
      return;
    }

    try {
      const specificBookingData = await getSpecificBooking(booking.bookingId);
      console.log("specific booking data: ", specificBookingData);
      setSpecificBooking(specificBookingData);

      if (booking.signeeId && booking.contractId) {
        const contract = await getUserContract(
          booking.contractId,
          booking.signeeId,
        );
        setUserContract(contract);
        console.log("user contract: ", contract);
      } else {
        setUserContract(null);
      }


      const step = await getBookingStep(booking);
      setBookingStep(step);
      const difference = await checkMantencion(booking);
      setMantencionDifference(difference);

      if (difference > 0) {
        setIsPopUpVisible(true);
      }

      if (step === 3) { // Post Termino 100% ó Post Instalation
        console.log("fetching production data");
        const hourlyProductionData = await getHourlyProductionData();
        setHourlyProductionData(hourlyProductionData);
        console.log("Hourly Production Data fetched: ", hourlyProductionData);

        const dailyProductionData = await getDailyProductionData();
        setDailyProductionData(dailyProductionData);
        console.log("DailyProduction Data fetched: ", dailyProductionData);

        const installationDocs = await getInstallationDocuments(booking);
        setInstallationDocuments(installationDocs);
        console.log("installation documents: ", installationDocs);
        const installationMedia = await getInstallationMedia(booking);
        setInstallationMedia(installationMedia);
        console.log("installation media: ", installationMedia);
      }

    } catch (error) {
      console.error("Error fetching specific booking or booking step:", error);
    }
  };

  const handleSelectBooking = async (index: number) => {
    setSelectedBookingIndex(index);
    setLoading(true);
    await fetchSpecificBookingAndStep(index);
    setLoading(false);
  };

  const handleClosePopUp = () => {
    setIsPopUpVisible(false);
  };

  if (loading || !specificBooking) {
    return (
      <div>
        <HomeBanner
          userBookings={userBookings}
          userData={userData}
          selectedBookingIndex={selectedBookingIndex}
          onSelectBooking={handleSelectBooking}
        />
        <LoadingWheel view="home" />
      </div>
    );
  }

  return (
    <div>
      <div>
      <HomeBanner
        userBookings={userBookings}
        userData={userData}
        selectedBookingIndex={selectedBookingIndex}
        onSelectBooking={handleSelectBooking}
      />
      {isPopUpVisible && (
        <PopUpMantencion
          difference={mantencionDifference}
          isVisible={isPopUpVisible}
          onClose={handleClosePopUp}
        />
      )}
      {bookingStep === -1 && (
        <HomePreSigned
          userData={userData}
          userBooking={userBookings[selectedBookingIndex]}
          specificBooking={specificBooking}
        />
      )}
        {bookingStep === 0 && (
        <HomePreSigned
          userData={userData}
          userBooking={userBookings[selectedBookingIndex]}
          specificBooking={specificBooking}
        />
      )}
      {bookingStep === 1 && (
        //<HomePending2nd
        <HomeSigned 
          userData={userData}
          userBooking={userBookings[selectedBookingIndex]}
          specificBooking={specificBooking}
        />
      )}
      {bookingStep === 2 && (
          <HomeEntreVisitaInstall //<HomePostInstalation // Change to 'Entre Visita / Intalación'
          userData={userData}
          userBooking={userBookings[selectedBookingIndex]}
          specificBooking={specificBooking}
          userContract={userContract}
        />
      )}
      {bookingStep === 3 && (
        //<HomePostInstalation // Change to 'Post Término 100%'
        <HomePostTermino // Change to 'Post Término 100%'
          userData={userData}
          userBooking={userBookings[selectedBookingIndex]}
          specificBooking={specificBooking}
          userContract={userContract}
          bookingIndex={selectedBookingIndex}
          hourlyProductionData={hourlyProductionData}
          dailyProductionData={dailyProductionData}
          installationDocuments={installationDocuments}
          installationMedia={installationMedia}
        />
      )}
      {bookingStep === 4 && (
          <HomePending2nd //<HomePostTermino // Change to 'Pending 2nd Signature'
          userData={userData}
          userBooking={userBookings[selectedBookingIndex]}
          specificBooking={specificBooking}
        />
      )}
      {bookingStep === 4 && (
        <HomeSigned
          userData={userData}
          userBooking={userBookings[selectedBookingIndex]}
          specificBooking={specificBooking}
        />
      )}
        {bookingStep === 6 && (
          <HomePending2nd
            userData={userData}
            userBooking={userBookings[selectedBookingIndex]}
            specificBooking={specificBooking}
          />
        )}
        {bookingStep === 7 && (
          <HomeEntreVisitaInstall
            userData={userData}
            userBooking={userBookings[selectedBookingIndex]}
            specificBooking={specificBooking}
            userContract={userContract}
        /> 
        )}
        
      </div>
      
      {/*
      <div className="flex justify-center mt-10">
        <Footer/>
      </div>
      */}
      
    </div>
  );
};

export default Home;
